import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import showAlert from '../../../common/utils/alert';
import { ParentContentCardMultiHeader } from '../../common/ParentContentCardMultiHeader';
import { EncryptionSettingForm } from './EncryptionSettingForm';
import ToggleButton from '../../../common/ui/ToggleButton';
import { checkEncryptionPermission, DATA_ENCRYPTION } from '../../../common/utils/permissions';
import ParentContentCard from '../../common/ParentContentCard';
import PermissionDenied from '../../../common/PermissionDenied';

export const EncryptionTab = ({
  projectId,
  projectDetail,
  environments,
  version,
  toggleEncryption,
  updateEncryptionSetting,
  updateEncAwsSetting,
  resetEncryptionSetting,
  cypherText,
}) => {
  const [activeEnv, setActiveEnv] = useState('PREVIEW');
  const switchEnvTab = (tab) => {
    if (activeEnv !== tab) setActiveEnv(tab);
  };
  const { enableEncryption, encryptions, seoName } = projectDetail;
  const handleToggleEncryption = () => {
    const preConfirm = () => toggleEncryption({ projectId, version, data: {} });
    showAlert(
      enableEncryption
        ? 'Disable Data Encryption for the project'
        : 'Enable Data Encryption for the project',
      preConfirm,
      enableEncryption ? 'Yes, disable it!' : 'Yes, enable it!',
    );
  };

  const loadKMSSetting = (envType) => {
    const encryption = encryptions.find((enc) => enc.envType === envType);

    return (
      <EncryptionSettingForm
        envType={envType}
        projectId={projectId}
        version={version}
        encryption={encryption}
        seoName={seoName}
        environments={environments}
        updateEncryptionSetting={updateEncryptionSetting}
        updateEncAwsSetting={updateEncAwsSetting}
        resetEncryptionSetting={resetEncryptionSetting}
        cypherText={cypherText}
      />
    );
  };

  const isAllowed = checkEncryptionPermission();

  if (!isAllowed) {
    return <PermissionDenied message="Data Encryption" />;
  }

  return (
    <ParentContentCardMultiHeader
      title="Data Encryption using KMS"
      icon="encryption"
      bgColor="drapcode-violet"
      projectId={projectId}
      version={version}
      CtaComponent={
        <div className="form-group">
          <div className="form-check mr-2" style={{ marginTop: 'revert', display: 'inline-block' }}>
            <ToggleButton
              name="enableEncryption"
              className="form-check-input"
              title="Enable Data Encryption (Default: Disabled)"
              text="Enable Encryption"
              onChange={handleToggleEncryption}
              isChecked={enableEncryption}
            ></ToggleButton>
          </div>
        </div>
      }
    >
      {enableEncryption && (
        <>
          <Nav pills className="nav-pills-primary drapcode-nav-pills">
            {environments.map((environment) => (
              <NavItem key={environment.envType}>
                <NavLink
                  className={classnames({ active: activeEnv === environment.envType })}
                  onClick={() => switchEnvTab(environment.envType)}
                >
                  {environment.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeEnv}>
            {environments.map((environment) => (
              <TabPane tabId={environment.envType} key={environment.envType}>
                {loadKMSSetting(environment.envType)}
              </TabPane>
            ))}
          </TabContent>
        </>
      )}
    </ParentContentCardMultiHeader>
  );
};
